import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent } from '@sb/library/base';
import { WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';

@Component({
    selector: 'lib-gallery-column-design-block',
    templateUrl: './gallery-column-design-block.component.html',
    styleUrls: ['./gallery-column-design-block.component.scss']
})
export class GalleryColumnDesignBlockComponent extends DesignBlockBaseViewComponent {

    @Input() websiteBlockData!: WebsiteBlockTextAndMediaDisplayItem;

    get hasHeader(): boolean {
        return this.websiteBlockData.Header !== null;
    }

    get kind(): WebsiteBlockTextAndMediaType {
        return this.websiteBlockData.TextAndMediaType;
    }
}
